import classNames from 'classnames';
import React from 'react';

import AvatarInput from '../../../../../../../common/components/AvatarInput';
import { useWidget } from '../../../../../../../contexts/widgets';
import { forwardResizedImage } from '../../../../../../../services/event-handler';
import { ProfileLayout } from '../../../../../../../types';
import styles from './Avatar.scss';

export const Avatar = () => {
  const { member, profilePage, computed, handlers } = useWidget();

  const { isProfilePreview, isEditing, editPicture } = profilePage;
  const { canEdit, profileImageSize, showTitle } = computed;
  const { setMemberPicture, setEditPicture } = handlers;

  const handlePhotoChange = forwardResizedImage(setMemberPicture);
  const handlePhotoUpload = forwardResizedImage(setEditPicture);
  const hasTitle = !!member.title && showTitle;

  return (
    <AvatarInput
      className={classNames({
        [styles.profilePhoto]: true,
        [styles.noTitle]: !hasTitle,
      })}
      name={member.name}
      url={(editPicture && editPicture.file) || member.picture}
      onClick={isEditing ? handlePhotoUpload : handlePhotoChange}
      canUpload={!isProfilePreview && canEdit}
      profileLayout={ProfileLayout.FullWidth}
      imageSize={profileImageSize}
    />
  );
};
